import axios from 'axios';
import { API_KEY } from '../config/appConfig';
import { CultureHelper } from '../helpers/cultureHelper';

const signingAxios = axios.create({
    baseURL: `${API_KEY}/api/`,
    headers: { 'Content-Type': 'application/json' },
    validateStatus: (status) => status >= 200 && status < 300,
});

signingAxios.interceptors.request.use((config) => {
    config.params = { ...config.params, culture: CultureHelper.currentCulture() };
    return config;
});

export default signingAxios;
